import { Trainer } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

/**
 * `enabled` exists so a consumer that already has the trainer data it needs can switch the
 * request off while still calling the hook unconditionally — React forbids conditional hooks.
 * `WorkoutCardTrainer` uses it on the public login page, where `/trainers` is guarded and
 * firing this request would have a signed-out visitor attempting a token refresh.
 */
export const useTrainers = ({ enabled = true }: { enabled?: boolean } = {}): UseQueryResult<Trainer[], Error> => {
  return useQuery<Trainer[], Error>(queryKeys.trainers(), () => coreService.getTrainers(), {
    keepPreviousData: true,
    enabled,
  })
}

export const useTrainer = (trainerId: string | undefined): UseQueryResult<Trainer, Error> => {
  return useQuery<Trainer, Error>(
    queryKeys.trainer(trainerId || ''),
    () => coreService.getTrainer({ trainerId: trainerId as string }),
    {
      enabled: !!trainerId && trainerId !== '',
      keepPreviousData: true,
    },
  )
}
